import { IS_CLIENT } from '../../constants';
export const getWrappedSrc = (source, width, useDevPrefixedUrl) => {
    let mappedSrc = decodeURIComponent(source);
    mappedSrc = mappedSrc.replace(/\s/g, '%20');
    // hm.options.isPublishMode is true for prod / test environments and false in author mode. We disable LP wrapping in author mode.
    const isPublishMode = IS_CLIENT &&
        window.hm &&
        window.hm.options &&
        window.hm.options.isPublishMode;
    // If author is viewing preview of published page the isPublishMode will be true. This query will let us know not to use LP syntax for this usecase.
    const isPublishModeInAemEditor = IS_CLIENT && window.location.href.includes('?wcmmode=disabled');
    if (isPublishMode === false || isPublishModeInAemEditor) {
        return source;
    }
    const envString = useDevPrefixedUrl ? 'dev' : 'prod';
    if (!mappedSrc.includes('source=url[')) {
        const fileType = mappedSrc.includes('.png') ? 'png' : 'jpeg';
        return `https://lp2.hm.com/hmgoep${envString}?source=url[${mappedSrc}]&scale=size[${width}]&sink=format[${fileType}],quality[80]`;
    }
    if (useDevPrefixedUrl && mappedSrc.indexOf('hmgoepprod') !== -1) {
        mappedSrc = mappedSrc.replace(/hmgoepprod/, 'hmgoepdev');
    }
    return mappedSrc.replace(/size\[[^\]]*\]/, `size[${width}]`);
};
//# sourceMappingURL=getWrappedSrc.js.map